import PropTypes from "prop-types";
import React from "react";
import { Link,Route } from "react-router-dom";

/**
 * A ReactRouter Link which sets the vanilla selected
 * class on the parent li when the route matches.
 */
export default function NavItem({ children, to, exact }) {
  return (
    <Route path={to} exact={exact}>
      {({ match }) => (
        <li className={`p-navigation__link ${match && "is-selected"}`}>
          <Link to={to}>{children}</Link>
        </li>
      )}
    </Route>
  );
}

NavItem.defaultProps = {
  exact: false
};

NavItem.propTypes = {
  to: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  children: PropTypes.node.isRequired
};
